var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._v("Value1: "+_vm._s(_vm.val1))]),(_vm.val2)?_c('div',[_vm._v("Value2: "+_vm._s(_vm.val2))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }